"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScatterPlot = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var dimensions_1 = require("../_commons/dimensions");
var CoreScatterPlot_1 = require("./CoreScatterPlot");
var withChart_1 = require("../_base/withChart");
//
// Internals
//
var scatterPlotDefinition = {
    chartName: "ScatterPlot",
    bucketPropsKeys: ["xAxisMeasure", "yAxisMeasure", "attribute", "filters", "sortBy"],
    bucketsFactory: function (props) {
        return [
            sdk_model_1.newBucket(sdk_ui_1.BucketNames.MEASURES, props.xAxisMeasure),
            sdk_model_1.newBucket(sdk_ui_1.BucketNames.SECONDARY_MEASURES, props.yAxisMeasure),
            sdk_model_1.newBucket(sdk_ui_1.BucketNames.ATTRIBUTE, props.attribute),
        ];
    },
    executionFactory: function (props, buckets) {
        var _a;
        var backend = props.backend, workspace = props.workspace, execConfig = props.execConfig;
        return (_a = backend
            .withTelemetry("ScatterPlot", props)
            .workspace(workspace)
            .execution()
            .forBuckets(buckets, props.filters))
            .withSorting.apply(_a, props.sortBy).withDimensions(dimensions_1.pointyChartDimensions)
            .withExecConfig(execConfig);
    },
};
var WrappedScatterPlot = withChart_1.withChart(scatterPlotDefinition)(CoreScatterPlot_1.CoreScatterPlot);
/**
 * [ScatterPlot](http://sdk.gooddata.com/gooddata-ui/docs/scatter_plot_component.html)
 *
 * Scatter plot shows data as points using Cartesian coordinates.
 *
 * Scatter plots typically have a minimum of two measures, one for the X-axis and the other for the Y-axis, and one
 * attribute, which determines the meaning of each data point. Scatter plots are useful for analyzing trends between
 * two measures or for tracking the magnitude of two measures from the same chart.
 *
 * @public
 */
exports.ScatterPlot = function (props) {
    var _a = sdk_ui_1.useResolveValuesWithPlaceholders([props.xAxisMeasure, props.yAxisMeasure, props.attribute, props.filters, props.sortBy], props.placeholdersResolutionContext), xAxisMeasure = _a[0], yAxisMeasure = _a[1], attribute = _a[2], filters = _a[3], sortBy = _a[4];
    return (react_1.default.createElement(WrappedScatterPlot, tslib_1.__assign({}, props, {
        xAxisMeasure: xAxisMeasure,
        yAxisMeasure: yAxisMeasure,
        attribute: attribute,
        filters: filters,
        sortBy: sortBy,
    })));
};
//# sourceMappingURL=ScatterPlot.js.map